import { axiosWithAuth } from "helpers";

export const achProcessorService = {
	getMerchantAchProcessor,
	submitMerchantAchProcessor,
};

const API_URL = process.env.REACT_APP_API_URL;

function getMerchantAchProcessor(merchantId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/merchants/${merchantId}/ach`,
	};

	return axiosWithAuth(options);
}

function submitMerchantAchProcessor(merchantId, model) {
	const options = {
		method: "PUT",
		url: `${API_URL}/api/merchants/${merchantId}/ach`,
		data: model,
	};

	return axiosWithAuth(options);
}
